/* ── ELEMENT.CLOSEST POLYFILL ── */
if(!Element.prototype.closest){
  Element.prototype.closest = function(sel){
    var el = this;
    while(el && el.nodeType === 1){
      if(el.matches ? el.matches(sel) : el.msMatchesSelector(sel)){ return el; }
      el = el.parentElement || el.parentNode;
    }
    return null;
  };
}
if(!Element.prototype.matches){
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/* ── FETCH POLYFILL FOR OLDER BROWSERS ── */
if(!window.fetch){
  window.fetch = function(url, opts){
    return new Promise(function(resolve, reject){
      var xhr = new XMLHttpRequest();
      var method = (opts && opts.method) || 'GET';
      xhr.open(method, url, true);
      if(opts && opts.headers){
        Object.keys(opts.headers).forEach(function(k){ xhr.setRequestHeader(k, opts.headers[k]); });
      }
      xhr.onload = function(){
        var text = xhr.responseText;
        resolve({
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          json: function(){ return Promise.resolve(JSON.parse(text)); },
          text: function(){ return Promise.resolve(text); },
          clone: function(){ return { json: function(){ return Promise.resolve(JSON.parse(text)); } }; }
        });
      };
      xhr.onerror = function(){ reject(new Error('Network error')); };
      xhr.send(opts && opts.body ? opts.body : null);
    });
  };
}

/* ═════════════════════════════
   FAANi Grocery Scripts v4
   ══════════════════════════════ */

/* ── MOBILE MENU ── */
(function(){
  var btn=document.getElementById('mobileMenuBtn');
  var nav=document.getElementById('mobileNav');
  var overlay=document.getElementById('mobileOverlay');
  var close=document.getElementById('mobileClose');
  if(!btn||!nav)return;
  function open(){nav.style.display='block';document.body.style.overflow='hidden';}
  function shut(){nav.style.display='none';document.body.style.overflow='';}
  btn.addEventListener('click',open);
  if(close)close.addEventListener('click',shut);
  if(overlay)overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')shut();});
})();

/* ── MEGA MENU ── */
(function(){
  var trigger=document.getElementById('shopTrigger');
  var menu=document.getElementById('megaMenu');
  var wrap=document.getElementById('shopWrap');
  if(!trigger||!menu)return;
  trigger.addEventListener('click',function(e){
    e.stopPropagation();
    var isOpen=menu.classList.contains('open');
    menu.classList.toggle('open');
    trigger.setAttribute('aria-expanded',String(!isOpen));
  });
  document.addEventListener('click',function(e){
    if(wrap&&!wrap.contains(e.target)){
      menu.classList.remove('open');
      trigger.setAttribute('aria-expanded','false');
    }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      menu.classList.remove('open');
      trigger.setAttribute('aria-expanded','false');
    }
  });
})();

/* ── COUNTDOWN TIMERS ── */
(function(){
  function updateTimers(){
    var now=new Date();
    var end=new Date();
    end.setHours(23,59,59,999);
    var diff=Math.max(0,Math.floor((end-now)/1000));
    var h=String(Math.floor(diff/3600)).padStart(2,'0');
    var m=String(Math.floor((diff%3600)/60)).padStart(2,'0');
    var s=String(diff%60).padStart(2,'0');

    var ids=[
      ['fdH','fdM','fdS'],
      ['navH','navM','navS'],
      ['fh2','fm2','fs2']
    ];

    ids.forEach(function(group){
      var eh=document.getElementById(group[0]);
      var em=document.getElementById(group[1]);
      var es=document.getElementById(group[2]);
      if(eh)eh.textContent=h;
      if(em)em.textContent=m;
      if(es)es.textContent=s;
    });
  }
  /* Run immediately AND after DOM ready to catch elements added late */
  updateTimers();
  document.addEventListener('DOMContentLoaded', function(){
    updateTimers();
    setInterval(updateTimers,1000);
  });
  /* Also start interval immediately in case DOMContentLoaded already fired */
  setInterval(updateTimers,1000);
})();

/* ── AJAX ADD TO CART ── */
function faaniAddToCart(variantId, btn, featuredClass){
  if(!variantId)return;
  btn.disabled=true;
  var orig=btn.textContent;
  btn.textContent='…';

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:parseInt(variantId),quantity:1})
  })
  .then(function(r){return r.json();})
  .then(function(){
    btn.textContent='✓';
    btn.style.background='#27ae60';
    btn.style.borderColor='#27ae60';
    // Update cart count
    fetch('/cart.js')
      .then(function(r){return r.json();})
      .then(function(c){
        var els=document.querySelectorAll('.cart-count');
        els.forEach(function(el){el.textContent=c.item_count;});
      });
    setTimeout(function(){
      btn.textContent=orig;
      btn.style.background='';
      btn.style.borderColor='';
      btn.disabled=false;
    },1400);
  })
  .catch(function(err){
    console.error('Cart error:',err);
    btn.disabled=false;
    btn.textContent=orig;
  });
}

/* ── PRODUCT CARD ADD TO CART ── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.add-btn, .plus-btn, .faani-plus-btn, .fd-atc-btn, .car-add, .car-atc');
  if(!btn||btn.disabled)return;
  e.stopPropagation();
  var vid=btn.dataset.variantId||btn.dataset.variantId||btn.getAttribute('data-variant-id')||btn.getAttribute('data-vid');
  if(!vid)return;
  var qty=parseInt(btn.getAttribute('data-qty'))||1;
  var orig=btn.textContent;
  btn.disabled=true;
  btn.textContent='✓';
  btn.style.background='#27ae60';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:parseInt(vid),quantity:qty})
  }).then(function(r){return r.json();}).then(function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=c.item_count;});
    });
    setTimeout(function(){
      btn.textContent=orig;
      btn.style.background='';
      btn.disabled=false;
    },1400);
  }).catch(function(err){
    console.error('Cart error:',err);
    btn.disabled=false;
    btn.textContent=orig;
    btn.style.background='';
  });
});

/* ── WISHLIST BUTTONS ── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.wb-btn, .car-wl');
  if(!btn)return;
  e.stopPropagation();
  var on=btn.textContent==='♥';
  btn.textContent=on?'♡':'♥';
  btn.style.background=on?'':'#e53935';
  btn.style.color=on?'':'#fff';
  btn.style.borderColor=on?'':'#e53935';
});

/* ── PRODUCT PAGE QTY ── */
(function(){
  var minus=document.getElementById('qty-minus');
  var plus=document.getElementById('qty-plus');
  var input=document.getElementById('qty-input');
  if(!minus||!plus||!input)return;
  minus.addEventListener('click',function(){
    var v=parseInt(input.value)||1;
    if(v>1)input.value=v-1;
  });
  plus.addEventListener('click',function(){
    var v=parseInt(input.value)||1;
    input.value=v+1;
  });
})();

/* ── PRODUCT PAGE ADD TO CART ── */
(function(){
  var atcBtn=document.getElementById('atc-btn');
  if(!atcBtn)return;
  atcBtn.addEventListener('click',function(){
    var vid=this.dataset.variantId;
    var qty=parseInt(document.getElementById('qty-input')?.value||1);
    if(!vid)return;
    var self=this;
    self.disabled=true;
    var orig=self.textContent;
    self.textContent='Adding…';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:parseInt(vid),quantity:qty})
    })
    .then(function(r){return r.json();})
    .then(function(){
      self.textContent='✓ Added to Cart!';
      self.style.background='#27ae60';
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var els=document.querySelectorAll('.cart-count');
        els.forEach(function(el){el.textContent=c.item_count;});
      });
      setTimeout(function(){
        self.textContent=orig;
        self.style.background='';
        self.disabled=false;
      },2000);
    })
    .catch(function(){
      self.disabled=false;
      self.textContent=orig;
    });
  });
})();

/* ── CART QTY UPDATE ── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.cart-qty-btn');
  if(!btn)return;
  var dir=parseInt(btn.dataset.dir||'0');
  var key=btn.dataset.key;
  var qtyWrap=btn.closest('.cart-item-qty'); var numEl=qtyWrap?qtyWrap.querySelector('.cart-qty-num'):null;
  if(!key||!numEl)return;
  var current=parseInt(numEl.textContent)||1;
  var newQty=Math.max(0,current+dir);
  numEl.textContent=newQty;
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:newQty})
  })
  .then(function(r){return r.json();})
  .then(function(cart){
    var els=document.querySelectorAll('.cart-count');
    els.forEach(function(el){el.textContent=cart.item_count;});
    if(newQty===0)location.reload();
  });
});

/* ── CAROUSEL ARROWS ── */
document.addEventListener('click',function(e){
  var btn=e.target.closest('.car-arrow, .car-btn');
  if(!btn)return;
  var dir=parseInt(btn.dataset.dir||btn.id?.includes('Prev')?'-1':'1')||1;
  var carSec=btn.closest('.car-sec, .carousel-section'); var track=carSec?carSec.querySelector('.carousel-track, .car-track'):null;
  if(track)track.scrollBy({left:dir*210,behavior:'smooth'});
});

/* ── CAROUSEL TABS ── */
document.addEventListener('click',function(e){
  var tab=e.target.closest('.car-tab');
  if(!tab)return;
  var container=tab.closest('.car-sec, .carousel-section') || null;
  if(!container)return;
  container.querySelectorAll('.car-tab').forEach(function(t){t.classList.remove('active','on');});
  tab.classList.add('active','on');
  var filter=tab.dataset.filter||'all';
  var track=container.querySelector('.carousel-track, .car-track');
  if(!track)return;
  track.querySelectorAll('.car-card').forEach(function(card){
    if(filter==='all'||!card.dataset.tags||(card.dataset.tags&&card.dataset.tags.indexOf(filter)>-1)){
      card.style.display='';
    } else {
      card.style.display='none';
    }
  });
  track.scrollTo({left:0,behavior:'smooth'});
});

/* ── CATEGORY PILL CLICKS ── */
document.addEventListener('click',function(e){
  var pill=e.target.closest('.cat-pill');
  if(!pill)return;
  var container=pill.closest('.cat-pills') || null;
  if(!container)return;
  container.querySelectorAll('.cat-pill').forEach(function(p){p.classList.remove('active');});
  pill.classList.add('active');
});

/* ── SMOOTH SCROLL ── */
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var target=document.querySelector(this.getAttribute('href'));
    if(target){
      e.preventDefault();
      target.scrollIntoView({behavior:'smooth',block:'start'});
    }
  });
});
